<mat-card appearance="outlined">
    <mat-card-content style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
        <div>
            <button mat-icon-button [attr.aria-label]="'Move '+ card.options.title" i18n>
                <mat-icon>drag_indicator</mat-icon>
            </button>
        </div>
        <div style="flex-grow: 1;">
          <h3>{{ card.options.title }}</h3>
          <span class="text-muted">{{card.type.title}}</span>
        </div>
        <div style="display: flex; flex-direction: row;">
            @if (card.isConfigurable) {
                <button mat-icon-button
                        [attr.aria-label]="'Edit '+ card.options.title" i18n
                        (click)="onEdit()">
                    <mat-icon>settings</mat-icon>
                </button>
            }
            <button mat-icon-button
                    [attr.aria-label]="'Delete '+ card.options.title" i18n
                    (click)="onDelete()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </mat-card-content>
</mat-card>
